import { Link } from '@radix-ui/themes'
import { Link as RouterLink } from '@tanstack/react-router'
import type { ComponentProps, MouseEvent } from 'react'

interface OrgLinkProps {
  orgId: string
  name: string
  size?: ComponentProps<typeof Link>['size']
  className?: string
  onClick?: (event: MouseEvent) => void
}

// Every org name in the app routes here. Kept as one component because the destination is a
// product decision, not a per-call-site one — hand-written routes drifted before, leaving the
// same page linking an org two different ways.
export const OrgLink = ({ orgId, name, size, className, onClick }: OrgLinkProps) => (
  <Link asChild size={size} className={className} onClick={onClick}>
    <RouterLink to="/organizations" search={{ orgId }}>
      {name}
    </RouterLink>
  </Link>
)
